//reducer is where state goes
// action dispatch to reducer
//e.g. getItems dispatch to reducer
// send response (state) from server to reducer

import { GET_MENU, MENU_LOADING } from "../actions/types";

const initialState = {
  menu: [],
  loading: false
  // when we fetch data takes some ms to get
};

//will later get state from api

export default function(state = initialState, action) {
  switch (action.type) {
    // checking action from itemActions -> type is name of action
    case GET_MENU:
      return {
        ...state,
        menu: action.payload,
        loading: false
        // before request items_loading was set to true
      };
    case MENU_LOADING:
      return {
        ...state,
        loading: true
        // ... -> because hardcopy we cannot modify it
      };
    default:
      return state;
  }
}
